import React, { useState, useEffect } from "react";
import "./index.scss";
import { getPhone } from "../../../../utils/msg";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

function Electronic() {
    const { t } = useTranslation();
    const language = localStorage.getItem("i18nextLng");
    const talentContent = t("residency.space_part6", {
      returnObjects: true,
    });
  return (
    <div className="talent_">
      <div className="talent_introduce">
        <div className="talent_int_con">
          <div className="talent_int_title">{talentContent.introduceTitle}</div>
          <div className="talent_int_content">{talentContent.introduceContent}</div>
        </div>
      </div>
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{talentContent.title}</div>
            <div className="talent_title_undlineBox">
              <span className="talent_title_undline"></span>
            </div>
           <span>{talentContent.describe}</span>
        </div>
      </div>
      <div className="talent_con">
        {talentContent.list?.map((item0, index0) => {
          return (
            <div className="talent_li" key={index0}>
              <div>

              </div>
              <div className="talent_li_img">
                <img src={item0.iconUrl} alt="" />
              </div>
              <div className="talent_li_text">
                <div className="talent_li_til">{item0.itemTitle}</div>
                <div className="talent_li_con">{item0.itemContent}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Electronic;
